import { DataResult } from "@progress/kendo-data-query";
import { DATA_ITEM_KEY } from "./GridConstants";

export function removeFromDataResult(
  ids: Array<number | string>,
  dataResult: DataResult,
  setDataResult: (dataResult: DataResult) => void
): void {
  const data = dataResult.data.filter((item) => {
    return !ids.includes(item[DATA_ITEM_KEY]);
  });

  setDataResult({
    data,
    total: dataResult.total - ids.length,
  });
}
